module.exports = {

  components: {
    'mysharelist': require('../components/mysharelist.vue'),
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/myshare-view.vue
// module id = 155
// module chunks = 0